export default {
  phone: /^[0-9().\-/]+$/,
  phoneChars: /[.\-()]/g,
};